import React from 'react';
import './search-results.scss';

interface SearchResultsProps<T> {
  searchOptions: T[];
  onOptionSelected: (entry: T) => void;
  getDisplayLabel: (entry: T) => string;
  getDisplayValue: (entry: T) => string;
}

export const SearchResults = <T,>({
  searchOptions,
  onOptionSelected,
  getDisplayLabel,
  getDisplayValue,
}: SearchResultsProps<T>) => {
  const ref = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <article ref={ref} className="search-results-container">
      {searchOptions.map((option, index) => (
        <section
          key={`search-results-${getDisplayValue(option)}-${index}`}
          className="search-results"
          onClick={() => onOptionSelected(option)}
          onMouseDown={() => onOptionSelected(option)}
        >
          <aside className="small-label">{getDisplayLabel(option)}</aside>
          <p>{getDisplayValue(option)}</p>
          <hr />
        </section>
      ))}
    </article>
  );
};
